export default __webpack_public_path__ + "static/media/9H.18a09329.webp";